
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.298 14.342l6-5.974a.988.988 0 000-1.403.999.999 0 00-1.41 0l-6 5.973L7.89 6.965a.999.999 0 00-1.41 0 .988.988 0 000 1.403l6 5.974-6 5.973a.989.989 0 00.71 1.693c.26 0 .51-.1.71-.289l6-5.973 5.998 5.973c.2.2.45.289.71.289a.989.989 0 00.71-1.692l-6.019-5.974z"}})])
          )
        }
      }
    